import { useEffect, useRef } from "react";
import classNames from "classnames";
import InputGuideText from "@/components//input-guide-text";
import { TickSVG } from "@/components/svg";

export default function FormInput({
  label,
  required = true,
  autoFocus = false,
  className = "",
  showValidation = true,
  isValid,
  warnText = "",
  statusText = "",
  hasErrorStatus = false,
  showStatusText = false,
  ...props
}) {
  const inputRef = useRef(null);
  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  }, []);

  return (
    <div className="group">
      <label
        className={classNames(
          "block font-normal text-subheading-gray text-sm",
          "group-focus-within:text-dark-purple"
        )}
        htmlFor={props.name}
      >
        {label}
      </label>
      <div className="flex h-10 mt-1 relative rounded-xl">
        <input
          className={classNames(
            "block w-full pl-3 pr-10 py-2.5 text-gray-4",
            "text-sm rounded-xl border outline-none",
            "focus:border-light-purple focus:shadow-border-focus",
            "disabled:bg-gray-2 disabled:text-subtext-gray",
            !hasErrorStatus && (isValid || !showValidation || props.disabled)
              ? "border-border-dark-gray shadow-border"
              : "border-error-red shadow-border-error",
            className
          )}
          required={required}
          ref={autoFocus ? inputRef : null}
          id={props.name}
          {...props}
        />
        {showValidation && isValid && (
          <TickSVG
            className={classNames(
              "absolute right-2.5 top-[calc(50%-9px)] w-[18px]",
              "group-focus-within:invisible stroke-dark-purple"
            )}
          />
        )}
        {showValidation && !isValid && (
          <InputGuideText
            className="absolute top-10 mt-0.5 ml-0.5"
            isWarning={true}
          >
            {warnText}
          </InputGuideText>
        )}
        {showStatusText && (
          <InputGuideText
            className="absolute top-10 mt-0.5 ml-0.5"
            isWarning={hasErrorStatus}
          >
            {statusText}
          </InputGuideText>
        )}
      </div>
    </div>
  );
}
